import { ValidatedUrlModule_value as ValidatedUrlModule_value_1, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { Result_Map, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { record_type, lambda_type, union_type, list_type, unit_type, class_type, int32_type, option_type, anonRecord_type, string_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { PdfDownloadDTO$reflection, NoteKind, File$reflection, NoteResponse$reflection } from "./Model.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import * as react from "react";
import { ErrorModalProps, renderErrorModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { loadEffect, getTranslationFrom, LoadState$2 } from "../../Global.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { logei, getInitials, loge, DateTimeExtensions_toDateHHmm, stackClasses, Locale$reflection } from "../../Utils.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { length, singleton as singleton_2, ofArray, append, map, sortByDescending } from "../../fable_modules/fable-library.3.7.20/List.js";
import { compare } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { SveaIcon, renderSveaIcon, getFileEndingIcon, getWrappedMaterialIcon, dotsLoading } from "../../ViewUtils.js";
import { info, error } from "../../Components/Message/Message.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { ButtonProps, defaultProps, main } from "../../Components/Button/Button.js";
import { SimpleJson_tryParse } from "../../fable_modules/Fable.SimpleJson.3.21.0/SimpleJson.fs.js";
import { Convert_fromJson } from "../../fable_modules/Fable.SimpleJson.3.21.0/Json.Converter.fs.js";
import { createTypeInfo } from "../../fable_modules/Fable.SimpleJson.3.21.0/TypeInfo.Converter.fs.js";
import { create, match } from "../../fable_modules/fable-library.3.7.20/RegExp.js";
import { renderTHead, Elements_renderCell } from "../../Components/Table/Table.js";
import "../../../src/Containers/Invoicee/Notes.scss";


function Api_loadNotes(clientNr, invoiceeNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Invoicee/Notes/%i/%i"))(clientNr)(invoiceeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(NoteResponse$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(NoteResponse$reflection(), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(NoteResponse$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

function Api_saveNote(clientNr, invoiceeNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Invoicee/Notes/%i/%i"))(clientNr)(invoiceeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(anonRecord_type(["Text", string_type])), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

function maybeRenderErrorModal(getTranslation, state) {
    const matchValue = state[0];
    switch (matchValue.tag) {
        case 1:
        case 2: {
            return react.createElement(react.Fragment, {});
        }
        case 3: {
            return renderErrorModal(new ErrorModalProps(matchValue.fields[0], (_arg) => {
                state[1](new LoadState$2(0));
            }, getTranslation));
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}

function stopShowDrag(e) {
    e.preventDefault();
    const elem = e.currentTarget;
    elem.classList.remove("drag-parent");
}

export class NotesAndDocumentsProps extends Record {
    constructor(ClientNr, Locale, InvoiceeNr, LoadFilesFn, DeleteFileFn, UploadFileFn) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.Locale = Locale;
        this.InvoiceeNr = InvoiceeNr;
        this.LoadFilesFn = LoadFilesFn;
        this.DeleteFileFn = DeleteFileFn;
        this.UploadFileFn = UploadFileFn;
    }
}

export function NotesAndDocumentsProps$reflection() {
    return record_type("Containers.Invoicee.Notes.NotesAndDocumentsProps", [], NotesAndDocumentsProps, () => [["ClientNr", int32_type], ["Locale", Locale$reflection()], ["InvoiceeNr", class_type("System.Int64")], ["LoadFilesFn", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(File$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(File$reflection())]], [["ErrorValue", string_type]]])]))], ["DeleteFileFn", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["UploadFileFn", lambda_type(string_type, lambda_type(class_type("Browser.Types.Blob", void 0, Blob), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), string_type], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", string_type]]])])))]]);
}

export const renderNotesAndDocuments = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const filesState = react.useState(new LoadState$2(0));
    const loadFiles = () => {
        const matchValue = filesState[0];
        switch (matchValue.tag) {
            case 2:
            case 3: {
                const _arg = filesState[1](new LoadState$2(1));
                startImmediate(singleton.Delay(() => singleton.Bind(props.LoadFilesFn(), (_arg_1) => {
                    const result = _arg_1;
                    const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
                    filesState[1](arg);
                    return singleton.Zero();
                })));
                break;
            }
            case 1: {
                break;
            }
            default: {
                const _arg = filesState[1](new LoadState$2(1));
                startImmediate(singleton.Delay(() => singleton.Bind(props.LoadFilesFn(), (_arg_1) => {
                    const result = _arg_1;
                    const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
                    filesState[1](arg);
                    return singleton.Zero();
                })));
            }
        }
    };
    react.useEffect(loadFiles, []);
    const uploadFileMessage = react.useState(new LoadState$2(0));
    const uploadFileMessage_1 = react.useState(new LoadState$2(0));
    const deleteFileMessage = react.useState(new LoadState$2(0));
    const translationsLoadState_1 = useSelector((state_1) => state_1.Model.Translations);
    const getTranslation_1 = (key_1) => getTranslationFrom(translationsLoadState_1, key_1);
    const notesState = react.useState(new LoadState$2(0));
    const noteToBeSavedState = react.useState("");
    const errorMessageState = react.useState(void 0);
    const loadNotes = () => {
        notesState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(Api_loadNotes(props.ClientNr, props.InvoiceeNr), (_arg_4) => {
            let list_3;
            const result_2 = _arg_4;
            let arg_15;
            if (result_2.tag === 1) {
                arg_15 = (new LoadState$2(3, result_2.fields[0]));
            }
            else {
                const dto = result_2.fields[0];
                arg_15 = (new LoadState$2(2, sortByDescending((_arg_5) => {
                    if (_arg_5.tag === 1) {
                        return _arg_5.fields[0].AtUtc;
                    }
                    else {
                        return _arg_5.fields[0].Timestamp;
                    }
                }, (list_3 = map((arg_14) => (new NoteKind(1, arg_14)), dto.ContractHistory), append(map((arg_13) => (new NoteKind(0, arg_13)), dto.Notes), list_3)), {
                    Compare: compare,
                })));
            }
            notesState[1](arg_15);
            return singleton.Zero();
        })));
    };
    react.useEffect(loadNotes, []);
    const props_91 = [new HTMLAttr(65, stackClasses(ofArray(["notes-and-documents", "d-flex"])))];
    const children_88 = toList(delay(() => {
        let children_59;
        return append_1(singleton_1((children_59 = toList(delay(() => {
            let children_8;
            return append_1(singleton_1((children_8 = [getTranslation_1("Common.Notes")], react.createElement("h3", {}, ...children_8))), delay(() => {
                let children_58, children_54, children_48, children_46, props_45, children_52, children_50, children_56, children_10;
                const matchValue_2 = notesState[0];
                switch (matchValue_2.tag) {
                    case 1: {
                        return singleton_1(dotsLoading);
                    }
                    case 3: {
                        return singleton_1(error(matchValue_2.fields[0].split("")));
                    }
                    case 2: {
                        return singleton_1((children_58 = [(children_54 = [(children_48 = [(children_46 = [(props_45 = [new HTMLAttr(65, "left__area"), ["data-translation", "CustomerContract.Invoicee.Notes.WriteNotePlaceholder"], new HTMLAttr(115, 2048), new DOMAttr(9, (e_2) => {
                            const arg_25 = Browser_Types_Event__Event_get_Value(e_2);
                            noteToBeSavedState[1](arg_25);
                        }), new HTMLAttr(128, getTranslation_1("CustomerContract.Invoicee.Notes.WriteNotePlaceholder") + "...")], react.createElement("textarea", keyValueList(props_45, 1)))], react.createElement("div", {
                            className: "w-100",
                        }, ...children_46))], react.createElement("div", {
                            className: "create__left",
                        }, ...children_48)), (children_52 = [(children_50 = [main(new ButtonProps(getTranslation_1("CustomerContract.Invoicee.Notes.CreateNote"), defaultProps.Content, (_arg_7) => {
                            startImmediate(singleton.Delay(() => singleton.Bind(Api_saveNote(props.ClientNr, props.InvoiceeNr, {
                                Text: noteToBeSavedState[0],
                            }), (_arg_6) => {
                                const result_3 = _arg_6;
                                if (result_3.tag === 1) {
                                    errorMessageState[1](result_3.fields[0]);
                                    return singleton.Zero();
                                }
                                else {
                                    noteToBeSavedState[1]("");
                                    loadNotes();
                                    return singleton.Zero();
                                }
                            })));
                        }, defaultProps.Disabled, "create-note-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("div", {
                            className: "right__button",
                        }, ...children_50))], react.createElement("div", {
                            className: "create__right",
                        }, ...children_52))], react.createElement("div", {
                            className: "notes__create",
                        }, ...children_54)), (children_56 = map((noteKind) => {
                            let children_28, children_26, children_36, children_34, children_30, children_32, children_40, children_14, children_12, children_20;
                            if (noteKind.tag === 1) {
                                const ch_1 = noteKind.fields[0];
                                const matchValue_3 = SimpleJson_tryParse(ch_1.EventArgsJson);
                                if (matchValue_3 != null) {
                                    const json = matchValue_3;
                                    let matchValue_4;
                                    try {
                                        matchValue_4 = (new FSharpResult$2(0, Convert_fromJson(json, createTypeInfo(PdfDownloadDTO$reflection()))));
                                    }
                                    catch (ex) {
                                        matchValue_4 = (new FSharpResult$2(1, ex.message));
                                    }
                                    if (matchValue_4.tag === 1) {
                                        return error(matchValue_4.fields[0].split(""));
                                    }
                                    else {
                                        const dto_1 = matchValue_4.fields[0];
                                        const name_3 = "System";
                                        const timestamp_1 = DateTimeExtensions_toDateHHmm(props.Locale.ILocale, ch_1.AtUtc);
                                        let downloadLink_1;
                                        const matchValue_5 = ValidatedUrlModule_create(new UrlKind(3, toText(printf("/Data/Mortgage/%i/%i/invoiceeFilesByContractNr/%s"))(ch_1.ClientNr)(ch_1.ContractNr)(dto_1.Description.File)));
                                        if (matchValue_5.tag === 1) {
                                            loge(toText(printf("[PdfDownloadDTO] Can\u0027t create url. Msg: %s"))(matchValue_5.fields[0]));
                                            downloadLink_1 = "";
                                        }
                                        else {
                                            downloadLink_1 = ValidatedUrlModule_value_1(matchValue_5.fields[0]);
                                        }
                                        const children_42 = [(children_28 = [(children_26 = [getInitials(name_3)], react.createElement("div", {
                                            className: "left__ball",
                                            title: name_3,
                                        }, ...children_26))], react.createElement("div", {
                                            className: "note__left",
                                        }, ...children_28)), (children_36 = [(children_34 = [(children_30 = [toText(printf("\"%s\":"))(dto_1.Description.DownloadedTemplate)], react.createElement("div", {}, ...children_30)), (children_32 = [getWrappedMaterialIcon("description")], react.createElement("a", {
                                            href: downloadLink_1,
                                            target: "_blank",
                                            className: "invoice-table__download-pdf ml-2",
                                        }, ...children_32))], react.createElement("div", {
                                            className: "d-flex",
                                        }, ...children_34))], react.createElement("div", {
                                            className: "note__middle",
                                        }, ...children_36)), (children_40 = [react.createElement("div", {
                                            className: "right__timestamp",
                                        }, timestamp_1)], react.createElement("div", {
                                            className: "note__right",
                                        }, ...children_40))];
                                        return react.createElement("li", {
                                            className: "note",
                                        }, ...children_42);
                                    }
                                }
                                else {
                                    const children_24 = [getTranslation_1("Common.NoData")];
                                    return react.createElement("p", {
                                        ["data-translation"]: "Common.NoData",
                                    }, ...children_24);
                                }
                            }
                            else {
                                const note_1 = noteKind.fields[0];
                                let name_1;
                                let regexMatch;
                                const tupledArg = [note_1.Username, "^\\*?\\[\\d*\\](.*)$"];
                                regexMatch = match(create(tupledArg[1]), tupledArg[0]);
                                name_1 = ((regexMatch != null) ? (regexMatch[1] || "") : note_1.Username.trim());
                                const timestamp = DateTimeExtensions_toDateHHmm(props.Locale.ILocale, note_1.Timestamp);
                                const children_22 = [(children_14 = [(children_12 = [getInitials(name_1)], react.createElement("div", {
                                    className: "left__ball",
                                    title: name_1,
                                }, ...children_12))], react.createElement("div", {
                                    className: "note__left",
                                }, ...children_14)), react.createElement("div", {
                                    className: "note__middle",
                                }, note_1.Text), (children_20 = [react.createElement("div", {
                                    className: "right__timestamp",
                                }, timestamp)], react.createElement("div", {
                                    className: "note__right",
                                }, ...children_20))];
                                return react.createElement("li", {
                                    className: "note",
                                }, ...children_22);
                            }
                        }, matchValue_2.fields[0]), react.createElement("ol", {
                            className: "notes__list",
                            ["data-regression"]: "notes-list",
                        }, ...children_56))], react.createElement(react.Fragment, {}, ...children_58)));
                    }
                    default: {
                        return singleton_1((children_10 = [info(getTranslation_1("CustomerContract.Invoicee.Notes.WaitingToLoad").split(""))], react.createElement("div", {
                            ["data-translation"]: "CustomerContract.Invoicee.Notes.WaitingToLoad",
                        }, ...children_10)));
                    }
                }
            }));
        })), react.createElement("div", {
            className: "notes-section",
            ["data-regression"]: "notes-container",
        }, ...children_59))), delay(() => {
            let children_86, children_77, children_84;
            const matchValue_6 = filesState[0];
            switch (matchValue_6.tag) {
                case 1: {
                    return singleton_1(dotsLoading);
                }
                case 3: {
                    return singleton_1(error(matchValue_6.fields[0].split("")));
                }
                case 2: {
                    const rows_2 = map((file) => {
                        let children_6;
                        let downloadLink;
                        const matchValue_1 = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/Mortgage/%i/%i/invoiceeFilesByInternalFilename/%s"))(props.ClientNr)(props.InvoiceeNr)(file.InternalFilename)));
                        if (matchValue_1.tag === 1) {
                            logei(["Cant create url. Error msg: ", matchValue_1.fields[0]]);
                            downloadLink = "";
                        }
                        else {
                            downloadLink = ValidatedUrlModule_value_1(matchValue_1.fields[0]);
                        }
                        let tooltipString;
                        const arg_9 = getTranslation("FileUploadedTime");
                        const arg_7 = getTranslation("FileUploadedBy");
                        const arg_5 = getTranslation("FileName");
                        tooltipString = toText(printf("%s: %s\n%s: %s\n%s: %s"))(arg_5)(file.Filename)(arg_7)(file.UploadedBy)(arg_9)(file.Uploadedutc);
                        return [ofArray([new HTMLAttr(99, file.Filename), new DOMAttr(47, (e_1) => {
                            stopShowDrag(e_1);
                        })]), ofArray([react.createElement("span", {
                            className: "truncate",
                            ["data-toggle"]: "tooltip",
                            title: tooltipString,
                        }, file.Filename), react.createElement("span", {}, file.Uploadedutc), react.createElement("span", {}, file.UploadedBy), (children_6 = [getWrappedMaterialIcon(getFileEndingIcon(file.Filename))], react.createElement("a", {
                            href: downloadLink,
                            download: file.Filename,
                            target: "_blank",
                            className: "invoice-table__download-pdf",
                        }, ...children_6))]), file.InternalFilename];
                    }, matchValue_6.fields[0]);
                    return singleton_1((children_86 = [(children_77 = [getTranslation_1("Common.Documents")], react.createElement("h3", {}, ...children_77)), (children_84 = toList(delay(() => {
                        let headers, rows_1, children_75, children_73;
                        return append_1(singleton_1((headers = ofArray([getTranslation_1("FileName"), getTranslation_1("FileUploadedTime"), getTranslation_1("FileUploadedBy"), ""]), (rows_1 = map((tupledArg_1) => {
                            let children_65;
                            const rowId = tupledArg_1[2];
                            const tableCells = map(Elements_renderCell, tupledArg_1[1]);
                            let saveAndCancelIconCell;
                            const children_67 = [(children_65 = toList(delay(() => {
                                let children_62;
                                return singleton_1((children_62 = [getWrappedMaterialIcon("close")], react.createElement("span", {
                                    className: "cell__icon",
                                    onClick: (_arg_8) => {
                                        ((fid) => {
                                            const _arg_11 = loadEffect(() => {
                                                const a = props.DeleteFileFn(fid);
                                                return singleton.Delay(() => singleton.Bind(a, (_arg_3) => {
                                                    let res;
                                                    return singleton.Return((res = _arg_3, (void Result_Map((_arg_2) => {
                                                        loadFiles();
                                                    }, res), res)));
                                                }));
                                            }, (arg_12) => {
                                                deleteFileMessage[1](arg_12);
                                            });
                                            loadFiles();
                                        })(rowId);
                                    },
                                }, ...children_62)));
                            })), react.createElement("div", {
                                className: "cell__icon-wrap",
                            }, ...children_65))];
                            saveAndCancelIconCell = react.createElement("td", {
                                className: "cell",
                            }, ...children_67);
                            const props_72 = append(singleton_2(new HTMLAttr(99, rowId)), tupledArg_1[0]);
                            const children_69 = append(tableCells, singleton_2(saveAndCancelIconCell));
                            return react.createElement("tr", keyValueList(props_72, 1), ...children_69);
                        }, rows_2), (children_75 = [(children_73 = [renderTHead(headers), react.createElement("tbody", {
                            className: "body",
                        }, ...rows_1)], react.createElement("table", {
                            className: "notes-and-documents-editable-table",
                        }, ...children_73))], react.createElement("div", {}, ...children_75))))), delay(() => append_1(singleton_1(maybeRenderErrorModal(getTranslation_1, uploadFileMessage_1)), delay(() => append_1(singleton_1(maybeRenderErrorModal(getTranslation_1, deleteFileMessage)), delay(() => {
                            let children_81, children_79;
                            return (length(rows_2) === 0) ? singleton_1((children_81 = [renderSveaIcon(new SveaIcon(4)), (children_79 = [getTranslation_1("DropFilesHere")], react.createElement("p", {}, ...children_79))], react.createElement("div", {
                                className: "emptytable",
                            }, ...children_81))) : singleton_1(react.createElement(react.Fragment, {}));
                        }))))));
                    })), react.createElement("div", {
                        onPaste: (e_3) => {
                            const fileList = e_3.clipboardData.files;
                            if (fileList.length > 0) {
                                const file1 = fileList.item(0);
                                const content_1 = file1.slice();
                                const name = file1.name;
                                loadEffect(() => props.UploadFileFn(name, content_1), (arg_11) => {
                                    uploadFileMessage_1[1](arg_11);
                                });
                            }
                        },
                        onDragOver: (e_4) => {
                            const e = e_4;
                            e.preventDefault();
                            const elem = e.currentTarget;
                            if (((e.dataTransfer.types[0]) === "Files") && (!elem.classList.contains("drag-parent"))) {
                                elem.classList.add("drag-parent");
                            }
                        },
                        onDragLeave: (e_5) => {
                            stopShowDrag(e_5);
                        },
                        onDrop: (e_6) => {
                            stopShowDrag(e_6);
                            if (e_6.dataTransfer.files.length > 0) {
                                const file1_1 = e_6.dataTransfer.files.item(0);
                                const content_3 = file1_1.slice();
                                loadEffect(() => {
                                    const a_3 = props.UploadFileFn(file1_1.name, content_3);
                                    return singleton.Delay(() => singleton.Bind(a_3, (_arg_10) => {
                                        let res_1;
                                        return singleton.Return((res_1 = _arg_10, (void Result_Map((_arg_9) => {
                                            loadFiles();
                                        }, res_1), res_1)));
                                    }));
                                }, (arg_26) => {
                                    uploadFileMessage_1[1](arg_26);
                                });
                            }
                        },
                    }, ...children_84))], react.createElement("div", {
                        className: "document-section",
                    }, ...children_86)));
                }
                default: {
                    return singleton_1(react.createElement(react.Fragment, {}));
                }
            }
        }));
    }));
    return react.createElement("div", keyValueList(props_91, 1), ...children_88);
}, "notes", uncurry(2, void 0), void 0, "renderNotesAndDocuments", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoicee\\Notes.fs", 443);

